// Angular
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HammerGestureConfig } from '@angular/platform-browser';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { OverlayModule } from '@angular/cdk/overlay';
// Perfect Scroll bar
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// SVG inline 
import { InlineSVGModule } from 'ng-inline-svg';
// Env
import { environment } from '../environments/environment';

// NGX Permissions
import { NgxPermissionsModule } from 'ngx-permissions';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// State
import { metaReducers, reducers } from './core/reducers';
// Copmponents
import { AppComponent } from './app.component';
// Modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ThemeModule } from './components/theme/theme.module';
// Partials
import { PartialsModule } from './components/partials/partials.module';
import { GlobalErrorHandler } from './Services/chunckError.service';
// Layout Services
import {
	DataTableService,
	KtDialogService,
	LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SplashScreenService, 
	SubheaderService
} from './core/_base/layout';
// Auth
import { AuthModule } from './components/pages/auth/auth.module';
// CRUD
import { HttpUtilsService, LayoutUtilsService, TypesUtilsService } from './core/_base/crud';
// Config
import { LayoutConfig } from './core/_config/layout.config';
// Highlight JS
import { InterceptorService } from './Services/interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
// import { PrintModule } from './components/print/print.module';
import 'hammerjs';
import { GoogleAnalyticsService } from './Services/googleAnalytics.service';
// import { WebOPACModule } from './components/webOPAC/webOPAC.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuillModule } from 'ngx-quill';
import { defineLordIconElement } from "lord-icon-element";
import lottie from "lottie-web";
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { FirebaseConfigService } from './Services/firebase.service';
import * as firebase from 'firebase/app';
import { LoaderService } from './Services/initalLoader.service';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { CancelHttpInterceptor } from './Services/cancelHttp.interceptor';

// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300,
};
export class MyGestureConfig extends HammerGestureConfig {
	overrides = {
	  swipe: { direction: 31 },
	};
  }
// export function initializeFirebase(firebaseConfigService: FirebaseConfigService): () => Promise<any> {
// 	return () => firebaseConfigService.loadFirebaseConfig().then(config => {
// 		if (!firebase.apps.length) {
// 		  firebase.initializeApp(config); // Use the loaded config
// 		}
// 	  }).catch(err => {
// 		console.error('Firebase initialization failed:', err);
// 	  });
//   }

// export function initializeLayoutConfig(appConfig: LayoutConfigService) {
// 	// initialize app by loading default demo layout config
// 	return () => {
// 		if (appConfig.getConfig() === null) {
// 			appConfig.loadConfigs(new LayoutConfig().configs);
// 		}
// 	};
// }
// export function initializeApp(): () => Promise<void> {
// 	return () =>
// 	  new Promise<void>((resolve) => {
// 		// Simulate initialization tasks (e.g., fetching initial data, setting up configuration)
// 		// setTimeout(() => {
// 		  	console.log('hi')
// 		// }, 2000); // Replace with your actual initialization tasks
// 		resolve();
// 		// Hide the loader when initialization is complete
// 		// You can use a service to control the visibility of the loader
// 		// For simplicity, we'll set a global variable here
// 		window['appInitialized'] = true;
// 	  });
//   }
export function initializeAppFactory(
	layoutConfigService: LayoutConfigService,
	firebaseConfigService: FirebaseConfigService,
	loaderService: LoaderService
  ): () => Promise<void> {
	return () => {
	  return new Promise<void>((resolve) => {
		// Show the loader
		window['appInitialized'] = true;
		// loaderService.show();
  
		// Initialize layout configuration
		const layoutConfigInitializer = new Promise<void>((layoutResolve) => {
		  if (layoutConfigService.getConfig() === null) {
			layoutConfigService.loadConfigs(new LayoutConfig().configs);
		  }
		  layoutResolve();
		});
  
		// Asynchronously initialize Firebase without waiting
		firebaseConfigService.loadFirebaseConfig().then((config) => {
		  if (!firebase.apps.length) {
			firebase.initializeApp(config);
		  }
		}).catch((err) => {
		  // Handle Firebase initialization failure if needed
		  // console.error('Firebase initialization failed:', err);
		});
  
		// Only wait for layout configuration
		layoutConfigInitializer
		  .then(() => {
			setTimeout(() => {
			  loaderService.hide(); // Hide the loader
			  resolve();
			}, 1000);
		  })
		  .catch((err) => {
			// Handle layout initialization failure if needed
			// console.warn('Layout initialization failed:', err);
			loaderService.hide(); // Ensure loader is hidden even if layout fails
			resolve();
		  });
	  });
	};
  }
  
  
  
  
//   export function initializeFirebase(firebaseService: FirebaseConfigService): () => Promise<void> {
// 	return () =>
// 	  new Promise<void>((resolve, reject) => {
// 		setTimeout(() => {
// 			firebaseService.fetchFirebaseConfig();
// 		// Subscribe to the config and resolve the promise once the config is fetched
// 		firebaseService.firebaseConfig$.subscribe(config => {
// 		  if (config) {
// 			console.log("test",config)
// 			AngularFireModule.initializeApp(config)
// 			resolve(); // Resolve when the configuration is successfully fetched
// 		  } else {
// 			//reject('Failed to fetch Firebase configuration'); // Reject in case of an error
// 		  }
// 		}, error => {
// 		 // reject(error); // Handle any errors in the subscription
// 		});
// 		}, );
		
// 	  });
//   }

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		ReactiveFormsModule,
		AppRoutingModule,
		HttpClientModule,
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		StoreModule.forRoot(reducers, {metaReducers}),
		EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
		StoreDevtoolsModule.instrument(),
		AuthModule.forRoot(),
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,
		InlineSVGModule.forRoot(),
		ThemeModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		QuillModule.forRoot(),
		AngularFireModule.initializeApp({}),
    	AngularFireStorageModule,
    	AngularFireDatabaseModule,
		AngularFireAuthModule
	],
	exports: [],
	providers: [
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		KtDialogService,
		DataTableService,
		SplashScreenService,
		FirebaseConfigService,
		LoaderService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
			
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptorService,
			multi: true
		},
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: MyGestureConfig
		},	
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CancelHttpInterceptor,
			multi: true
		  },
		// {
		// 	// layout config initializer
		// 	provide: APP_INITIALIZER,
		// 	useFactory: initializeLayoutConfig,
		// 	deps: [LayoutConfigService], multi: true
		// },
		// {
		// 	provide: APP_INITIALIZER,
		// 	useFactory: initializeApp,
		// 	multi: true,
		//   },
		{
			provide: APP_INITIALIZER,
			useFactory: (layoutConfigService: LayoutConfigService, firebaseConfigService: FirebaseConfigService, loaderService: LoaderService) =>
			  initializeAppFactory(layoutConfigService, firebaseConfigService, loaderService),
			deps: [LayoutConfigService, FirebaseConfigService, LoaderService],
			multi: true,
		  },
		{provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
		{provide: ErrorHandler, useClass: GlobalErrorHandler},
		{provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
		// template services
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		GoogleAnalyticsService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor() {
		defineLordIconElement(lottie.loadAnimation);
	  }
}
